<template>
  <div class="xt-checkbox">
    <div class="xt-checkbox__unselected" v-show="!currentValue" @click.stop="changeValue"></div>
    <img :src="selectedImg" @click.stop="changeValue" class="xt-checkbox__selected" v-show="currentValue" />
    <div class="xt-checkbox__content" @click="onTextClick" :style="!preventTextClick ? 'cursor: pointer;' : ''">
      <slot/>
    </div>
  </div>
</template>
<script>
import defSelected from '../assets/icon_selected.svg'
import loginSelected from '../assets/login_selected.svg'
export default {
  props: {
    value: {
      type: [Boolean, String, Number],
      default: false
    },
    preventTextClick: {
      type: [Boolean],
      default: false
    }
  },
  data() {
    return {
      currentValue: this.value,
      defSelected: defSelected,
      loginSelected: loginSelected,
    }
  },
  computed:{
    selectedImg(){
      return  this.$route.path.indexOf('login') > 0 && !this.isMobile ? loginSelected :defSelected
    },
    isMobile(){
      return this.$root.isMobile
    }
  },
  watch: {
    value(val) {
      this.setCurrentValue(val);
    }
  },
  methods: {
    changeValue() {
      this.$emit('input', !this.currentValue)
    },
    setCurrentValue(value) {
      if (value === this.currentValue) return;
      this.currentValue = value;
    },
    onTextClick() {
      if (this.preventTextClick) {
        return
      }
      this.changeValue()
    }
  }
}
</script>
<style lang="less" scoped>
.xt-checkbox {
  display: flex;
  line-height: 14px;
  .xt-checkbox__unselected {
    width: 12px;
    height: 12px;
    flex: 0 0 12px;
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid #C4C5C8;
    margin-right: 3px;
    cursor: pointer;
  }
  .xt-checkbox__selected{
    width: 14px;
    height: 14px;
    flex: 0 0 14px;
    margin-right: 3px;
    cursor: pointer;
  }
  .xt-checkbox__content{
    display: flex;
    align-items: flex-start;
  }
}
</style>